import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import FriendlyDuration from 'components/FriendlyDuration';
import InlineList from 'components/InlineList';
import Icon from 'components/Icon';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SectionContentInfo(_ref) {
  var contentItemCount = _ref.contentItemCount,
    sectionDuration = _ref.sectionDuration,
    lockingInfoText = _ref.lockingInfoText,
    _ref$withLockIcon = _ref.withLockIcon,
    withLockIcon = _ref$withLockIcon === void 0 ? false : _ref$withLockIcon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Box, {
    dimmed: true,
    shrink: true,
    fontSize: "s",
    children: /*#__PURE__*/_jsxs(InlineList, {
      splitBy: "dot",
      display: "inline",
      children: [lockingInfoText && /*#__PURE__*/_jsxs(_Fragment, {
        children: [withLockIcon && /*#__PURE__*/_jsx(Icon, {
          vAlign: true,
          scale: 0,
          name: "lock",
          mr: "xxs"
        }), lockingInfoText]
      }), contentItemCount !== undefined && t('playlist_item_count', {
        count: contentItemCount
      }), sectionDuration > 0 && /*#__PURE__*/_jsx(FriendlyDuration, {
        value: sectionDuration * 60
      })]
    })
  });
}
export default SectionContentInfo;